import axios from 'axios';

export function fetchQuery(queryName, qry) {
  return axios.post('../qry/' + queryName, qry).then(response => response.data);
}

export function getFromWebAPi(url) {
  return axios.get(url).then(response => response.data);
}
